export const twoLetterIsoLanguage = (currentCulture) => {
    return currentCulture.replace(/-[a-z]+$/i, "");
};
